import React from 'react'
import PropTypes from 'prop-types'

import RaisedButton from 'material-ui/RaisedButton'
import CircularProgress from 'material-ui/CircularProgress'

export default class OnboardingButton extends React.Component {

  static propTypes = {
    loading: PropTypes.bool,
    onButtonClicked: PropTypes.func.isRequired
  }

  handleButtonClicked = event => {
    event.preventDefault()
    this.props.onButtonClicked()
  }

  render() {
    if (this.props.loading) {
      return <CircularProgress
        size={28}
        thickness={2}
        color='#fff'
        style={styles.loading} />
    }
    return (
      <RaisedButton
        style={styles.main}
        labelStyle={styles.label}
        buttonStyle={styles.button}
        label='Continue'
        labelColor='#fff'
        backgroundColor='#527da3'
        onTouchTap={this.handleButtonClicked} />
    )
  }

}

const styles = {

  main: {
    width: 260,
    height: 54,
    borderRadius: 27,
    backgroundColor: '#527da3',
    border: 'solid 1px #527da3'
  },

  button: {
    borderRadius: 27
  },

  loading: {
    width: 260,
    cursor: 'not-allowed',
    backgroundColor: '#527da3',
    height: 54,
    borderRadius: 27,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  
  label: {
    fontFamily: 'Roboto',
    fontSize: 24,
    fontWeight: 300
  }

}



// WEBPACK FOOTER //
// ./src/login/OnboardingButton.js